export default __webpack_public_path__ + "static/media/8.8865139e.svg";